import React, { useState, useEffect } from 'react';
import YouTubeVideo from './YouTubeVideo';  // Importing the YouTubeVideo component

const PlaylistVideos = ({ playlistId, apiKey, module }) => {
  const [videos, setVideos] = useState([]);  // State to hold the list of videos

  // Fetches playlist videos using YouTube API when the component mounts or when playlistId/apiKey changes
  useEffect(() => {
    const fetchPlaylistVideos = async () => {
      try {
        const response = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${playlistId}&key=${apiKey}&maxResults=25`
        );
        const data = await response.json();
        setVideos(data.items);  // Store fetched videos in the state
      } catch (error) {
        console.error("Error fetching playlist videos: ", error);
      }
    };

    fetchPlaylistVideos();  // Call the function to fetch data
  }, [playlistId, apiKey]);  // Trigger useEffect when playlistId or apiKey changes

  return (
    <div>
      {videos.map((video, index) => {
        if (module === "summary" && index === 0) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "risk" && index === 1) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "reviews" && index === 2) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "portfolio_overview" && index === 3) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "portfolio_objectives" && index === 4) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "portfolio_purpose" && index === 5) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "portfolio_gateways" && index === 6) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "portfolio_stakeholders" && index === 7) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "portfolio_team" && index === 8) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "portfolio_targets" && index === 9) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "portfolio_questions" && index === 10) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "programme" && index === 0) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "programme_summary" && index === 1) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "programme_stakeholder" && index === 2) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "programme_project" && index === 3) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "myaccount" && index === 2) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "budget" && index === 4) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "target_plan" && index === 1) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "address_book" && index === 0) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />; 
        } else if (module === "dashboards" && index === 3) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />; 
        } else if (module === "stakeholders_summary" && index === 0) { 
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />; // Stakeholders
        } else if (module === "stakeholders_address" && index === 1) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "stakeholders_plan" && index === 2) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "stakeholders_overview" && index === 3) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "stakeholders_associated_projects" && index === 4) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "stakeholders_assessment_esg" && index === 5) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "stakeholders_programme" && index === 6) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_activity_plan" && index === 13) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />; // control_panel
        } else if (module === "control_panel_field_config" && index === 14) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_factors" && index === 15) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_data_collection" && index === 16) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_fields" && index === 12) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_stages" && index === 11) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_gateway" && index === 10) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_job" && index === 9) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_outbox" && index === 8) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_permissions" && index === 7) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_prompts" && index === 6) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_setup" && index === 5) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_stakeholder_ass" && index === 4) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_stakeholder_table" && index === 3) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_usage_log" && index === 1) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_user_class" && index === 0) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        } else if (module === "control_panel_tooltips" && index === 2) {
          return <YouTubeVideo videoId={video.snippet.resourceId.videoId} />;
        }
        return null;
      })}
    </div>

  );
};

export default PlaylistVideos;
